import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class CaixaPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaPessoa } = this.props.filtros;

        if ((buscaDataIni) && (buscaDataFim)) {

            let dataIni = '';
            if ((buscaDataIni) && (buscaDataIni !== undefined)) {
                dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }
            let dataFim = '';
            if ((buscaDataFim) && (buscaDataFim !== undefined)) {
                dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            axios
                .get('/vendas/listaCarteiraCliente', {
                    params: {
                        print: true,
                        pessoa: buscaPessoa.key,
                        dataIni,
                        dataFim,
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: data.dados,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Carteira de Clientes
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.periodo + '       ' + (this.props.situacaoCaixa === 'X' ? 'NÃO CRIADO' : (this.props.situacaoCaixa === 1 ? 'ABERTO' : 'FECHADO'))}</span>

                                {this.props.pessoa.key ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Cliente: </span>
                                        <span>{this.props.pessoa.label}</span>
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde Vendas: </span>
                                <span>{this.props.qtdeVendas}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Vendas Totais: </span>
                                <span>R$ {this.renderValor(this.props.vendasTotais)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Ticket Médio: </span>
                                <span>R$ {this.renderValor(this.props.ticketMedio)}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Recebido: </span>
                                <span>R$ {this.renderValor(this.props.totalRecebido)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>À Receber: </span>
                                <span>R$ {this.renderValor(this.props.totalReceber)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Vencido: </span>
                                <span>R$ {this.renderValor(this.props.totalRecVenc)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.pes_codigo)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="pes_codigo"
                                    dataIndex="pes_codigo"
                                    title="Cliente"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pes_nome"
                                    dataIndex="pes_nome"
                                    title="Nome Cliente"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="ultVenda"
                                    dataIndex="ultVenda"
                                    title="Últ. Venda"
                                    render={this.renderData}
                                    width={90}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="qtdeVendas"
                                    dataIndex="qtdeVendas"
                                    title="Qtde Ven"
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vendasTotais"
                                    dataIndex="vendasTotais"
                                    title="Vend Tot"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="ticketMedio"
                                    dataIndex="ticketMedio"
                                    title="Ticket Méd"
                                    render={this.renderValor}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="totalRecebido"
                                    dataIndex="totalRecebido"
                                    title="Recebido"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="totalReceber"
                                    dataIndex="totalReceber"
                                    title="À Receber"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="totalRecVenc"
                                    dataIndex="totalRecVenc"
                                    title="Em Atraso"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default CaixaPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/CarteiraClientesPrintModal.js